import React from 'react';
import ProductListingLayoutProps from './ProductListingLayoutProps';
import DetailedListTopBar from '../DetailedListTopBar';

const DetailedList = ({ children }: ProductListingLayoutProps) => {
  return (
    <div>
      <DetailedListTopBar />
      <div className="grid grid-cols-1 [&_>div:first-child]:rounded-tl [&_>div:first-child]:rounded-tr [&_>div:first-child]:border-t [&_>div:last-child]:rounded-bl [&_>div:last-child]:rounded-br [&_>div:nth-of-type(even)]:bg-gray-50 [&_>div:nth-of-type(odd)]:bg-white [&_>div]:border-x [&_>div]:border-b [&_>div]:border-gray-200 lg:[&_>div]:border-none">
        {children}
      </div>
    </div>
  );
};

export default DetailedList;
